import { useMiniMap2Presenter } from '@Map/MiniMap2/MiniMap2Presenter';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { MiniShopFloorContent } from './MiniShopFloorContent';
import type { MiniShopFloorPresenter } from './MiniShopFloorPresenter';
import {
  MiniShopFloorPresenterContext,
  getMiniShopFloorPresenter,
} from './MiniShopFloorPresenter';

export const MiniShopFloor = observer(function MiniShopFloor() {
  const { activeFloorStore } = useMiniMap2Presenter();

  const [presenter] = useState<MiniShopFloorPresenter | undefined>(
    () => activeFloorStore && getMiniShopFloorPresenter(activeFloorStore)
  );

  useEffect(() => () => presenter?.destroy(), []);

  if (!presenter) {
    return null;
  }

  return (
    <MiniShopFloorPresenterContext.Provider value={presenter}>
      <MiniShopFloorContent />
    </MiniShopFloorPresenterContext.Provider>
  );
});
